
import deepClone from '../../foundation/js/deepClone'
import { dataLayerPurchase } from '../../foundation/js/dataLayerHelpers'
import fetchCartUtiltyFunction from './cart/fetchCartUtiltyFunction'

export default {
    namespaced: true,
    state: {
        items_in_cart: 0,
        show_msrp: false,
        cart_data : undefined,
        customer_service_reason_codes: undefined,
        customer_service_order_types: undefined,
        customer_service_order_type: undefined,
        checkout_forms: [],
        order_sent: false,
        user_accepted_terms: false,
        items_count: 0,
        cart_spinner_spinning: false
    },
    mutations:{
        start_cart_spinner(state){
            state.cart_spinner_spinning = true
        },
        stop_cart_spinner(state){
            state.cart_spinner_spinning = false
        },
        user_accepts_terms(state){
            state.user_accepted_terms = true
        },
        order_sent(state){
            state.order_sent = true
        },
        user_refuses_terms(state){
            state.user_accepted_terms = false
        },
        set_items_in_cart(state,count){
            state.items_in_cart = count
        },
        set_show_msrp(state,status){
            state.show_msrp = status
        },
        set_cart_data(state, data) {
            state.cart_data = data
            state.items_count = data.itemsCount
        },
        set_items_count(state,count){
            state.items_count = count
        },
        set_customer_service_reason_codes(state, payload) {
            const orderReasonCodes = payload.map(orderCode => {
                return {
                    displayValue : Object.values(orderCode)[0],
                    id : Object.keys(orderCode)[0]
                }
            })
            state.customer_service_reason_codes = orderReasonCodes
        },
        set_customer_service_order_types(state, payload) {
            const orderTypes = payload.map(orderCode => {
                return {
                    displayValue : Object.values(orderCode)[0],
                    id : Object.keys(orderCode)[0]
                }
            })
            state.customer_service_order_types = orderTypes
        },
        set_customer_service_order_type(state, payload) {
            state.customer_service_order_type = payload
        },
        set_selected_customer_service_reason(state, payload) {
            state.cart_data.orderLines = deepClone(state.cart_data.orderLines.map(orderLine => {
                if (orderLine.variantSku === payload.variantSku) {
                    orderLine.reasonCode = payload.selectedReason
                }
                return orderLine
            }))
        },
        register_checkout_form(state,formInfo){
            formInfo.ready = false
            state.checkout_forms.push(formInfo)
        },
        update_checkout_form(state,requestedForm){
            const formInfo = state.checkout_forms.find((form => form.name === requestedForm.name))
            formInfo.ready = requestedForm.ready
            formInfo.form = requestedForm.form
        }
    },
    getters: {
        selectedCustomerServiceOrderType_ReasonCode_is_CreditMemo(state) {
            return state.customer_service_order_type === 'Order' ||
                state.customer_service_order_type === 'Credit_Memo' ||
                state.customer_service_order_type === 'Return_Order'
        },
        getOrderLinesFromCart(state) {
            return state.cart_data ? state.cart_data.orderLines : []
        },
        getCartData(state) {
            return state.cart_data ? state.cart_data : {}
        },
        getReasonCodeViaVariantSku: (state) => (variantSku) => {
            const orderLine = state.cart_data.orderLines.find(orderLine => {
                return orderLine.variantSku === variantSku
            })
            return orderLine.reasonCode
        },
        allCheckoutFormsValid(state){
            return state.checkout_forms.reduce((status,form)=>{
                return status !== false && form.ready ? true : false
            },null)
        }
    },
    actions:{
        getCart(context) {
            const url = process.env.GET_CART_DATA
            return fetchCartUtiltyFunction(context, url, "", "Get cart failed")
        },
        
        getERPCart(context) {
            const url = process.env.GET_ERP_DATA
            return fetchCartUtiltyFunction(context, url, "", "Get cart failed")
        },

        completeCheckoutForm(context,formInfo){
            context.commit('update_checkout_form',formInfo)
        },

        addToCart(context, payload) {
            const url = process.env.ADD_TO_CART
            const body = {
                productSku: String(payload.productSku),
                variantSku: String(payload.variantSku),
                quantity: payload.quantity
            }

            return fetchCartUtiltyFunction(context, url, body, "Add to cart failed")
        },
        tryAddToCartByVariantSku(context, payload) {
            const url = process.env.TRY_ADD_TO_CART_SKU
            const body = {
                variantSku: String(payload.variantSku),
                quantity: payload.quantity
            }

            return fetchCartUtiltyFunction(context, url, body, "Add to cart failed")
        },

        tryAddToCartByVariantSkus(context, payload) {
            const url = process.env.TRY_ADD_TO_CART_SKUS
            const body = {
                products: [...payload]
            }

            return fetchCartUtiltyFunction(context, url, body, "Add to cart failed")
        },

        removeItemFromOrderline(context, payload) {
            const url = process.env.DELETE_ORDERLINE_FROM_CART
            const body = {
                productSku: String(payload.productSku),
                variantSku: String(payload.variantSku)
            }
            return fetchCartUtiltyFunction(context, url, body, "Remove orderline from cart failed")
        },

        updateProductInCart(context, payload) {
            const url = process.env.UPDATE_CART
            const body = {
                productSku: String(payload.productSku),
                variantSku: String(payload.variantSku),
                quantity: payload.quantity,
                reasonCode: context.getters.getReasonCodeViaVariantSku(payload.variantSku) || null
            }

            return fetchCartUtiltyFunction(context, url, body, "Updating cart failed")
        },

        getCartQuantity(context) {
            const url = process.env.GET_CART_QUANTITY
            
            fetch(url)
                .then(res => {
                    if(res.ok) return res.json()
                    throw new Error("Error in retrieving cart quantity")
                })
                .then(count => {    
                    context.commit('set_items_count',count)
                })
                .catch(err => {
                    console.error(err)
                })
        },

        goToConfirmation(context){
            const formData = deepClone(context.state.checkout_forms).map(form => {
                return {
                    name: form.name,
                    form: form.form.filter(field => !field.compareTo),
                    languageCode : document.documentElement.lang || ""
                }
            })

            const url = process.env.CONFIRM_REDIRECT_FROM_CART

            const contentType = "application/json"
            const fetchConfig = {
                method: process.env.METHOD_POST,
                body: JSON.stringify(formData),
                headers: { "Content-Type": contentType }
            }

            if (fetchConfig.method === 'GET') {
                delete fetchConfig.body
            }

            fetch(url, fetchConfig)
                .then(res => {
                    if(res.ok) {
                        return res.text()
                    } else {
                        context.commit('main/set_global_error_modal_visibility_state', true, { root : true })
                        throw new Error("Error in redirecting to confirmation")
                    }
                })
                .then(url => {    
                    url ? window.location.href = window.location.origin + url : context.commit('main/set_global_error_modal_visibility_state', true, { root : true })
                })
                .catch(err => {
                    console.error(err)
                })
        },

        goToCheckout(context) {
            const url = process.env.CHECKOUT_REDIRECT_FROM_CART
            const body = { 
                orderType : context.state.customer_service_order_type || "",
                languageCode : document.documentElement.lang || ""
            }
            
            const contentType = "application/json"
            const fetchConfig = {
                method: process.env.METHOD_POST,
                body: JSON.stringify(body),
                headers: { "Content-Type": contentType }
            }

            if (fetchConfig.method === 'GET') {
                delete fetchConfig.body
            }

            fetch(url, fetchConfig)
                .then(res => {
                    if(res.ok) {
                        return res.text()
                    } else {
                        context.commit('main/set_global_error_modal_visibility_state', true, { root : true })
                        throw new Error("Error in redirecting to checkout")
                    }
                })
                .then(url => {  
                    url ? window.location.href = window.location.origin + url : context.commit('main/set_global_error_modal_visibility_state', true, { root : true })
                })
              .catch(err => {
                    console.error(err)
                })
        },

        placeOrder(context){
            if (context.state.order_sent){
                throw new Error("Detected duplicated order request")
            }
            context.commit('order_sent', context.state);
            const url = process.env.PLACE_ORDER

            const bodyObject = {
                languageCode:document.documentElement.lang,
                externalReference: context.state.checkout_forms[0].form[0].value,
                comment: context.state.checkout_forms[0].form[1].value,
            }

            const contentType = "application/json"
            const fetchConfig = {
                method: process.env.METHOD_POST,
                body: JSON.stringify(bodyObject),
                headers: { "Content-Type": contentType }
            }

            if (fetchConfig.method === 'GET') {
                delete fetchConfig.body
            }

            fetch(url,fetchConfig)
                .then(res => {
                    if(res.ok) {
                        return res.json()
                    } else {
                        context.commit('main/set_global_error_modal_visibility_state', true, { root : true })
                        throw new Error("Error placing the order")
                    }
                })
                .then(json => { 
                    dataLayerPurchase(context.state.cart_data, json.erpOrderId)
                    json.result ? window.location.href = window.location.origin + json.result : context.commit('main/set_global_error_modal_visibility_state', true, { root : true })
                })
                .catch(err => {
                    console.error(err)
                })
            
        }
    }
}